<div class="modal get-pin" *ngIf="!hideModal">
    <div class="model-container">
        <div class="modal-header">
                <h3 class="modal-heading" translate>retrieve-pin.forgot-pin</h3>
                <img class="modal-close" (click)="closeDialog()" src="/assets/icon/primary-close.svg" alt="close-icon"
                    width="28" height="28">
        </div>
        <div class="modal-body">
            <div class="contents">
                <h5 class="note" translate>retrieve-pin.no-problem</h5>
                <h3 class="mdn">+{{data?.mdn}}</h3>
                <p class="caption subnote" translate>retrieve-pin.pin-is-valid</p>
            </div>
            <div class="modal-actions">
                <a (click)="closeDialog()" translate>retrieve-pin.cancel</a>
                <button class="button primary" aria-label="Send Now" (click)="getPin()" translate>retrieve-pin.send-now</button>
            </div>
        </div>
    </div>
</div>